import css from "styled-jsx/css";
import colors from "../../../config/colors";
import font from "../../../config/fonts";
export const ButtonComponentStyle = css`
	.buttonText {
		font-family: ${font.medium};
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: ${colors.Black23};
		cursor: pointer;
	}
	.transparant-btn {
		background: none;
		border: none;
		outline: none;
	}
	.transparant-btn:hover {
		// background-color: rgba(255, 255, 255, 0.25);
	}
	.image-box {
		padding-right: 8px;
	}
	.button-hide {
		display: none;
	}
	.btnTextSizingMobile {
		font-size: 14px;
	}
	.out-of-stock-disabled-btn {
		color: ${colors.Grey20}; !important;
	}
`;
